module.exports = {
  clientId: 189672,
  firstName: null,
  lastName: null,
  email: 'support-employee@climate.com',
  userType: 'employee',
  hybridUser: false,
};
